/**
 * 通过流水线注入的环境配置等相关字段
 */
export const ENV = {
  /** 是否为正式环境，与之对应的是预发布，测试环境和开发环境，现网正式环境部署的一定是生产环境的代码 */
  isProd: !!process.env.IS_PROD,
  /** 是否为internal版本（公司内部使用的公网访问版） */
  isInternal: process.env.APP_VERSION === 'internal',
  /** 是否为新加坡海外版（历史字段名保留，避免扩大影响面） */
  isGlobal: process.env.APP_VERSION === 'sgp',
  /** 是否为欧洲海外版 */
  isEu: process.env.APP_VERSION === 'eu',
  /** 是否为海外版本 */
  isOverseas: process.env.APP_VERSION === 'sgp' || process.env.APP_VERSION === 'eu',
  isPro: process.env.APP_VERSION === 'pro',
  isWOA: process.env.APP_VERSION === 'woa',
  currentAppVersion: process.env.APP_VERSION,
  /** 本次发布对应的版本（tag） */
  releaseTag: process.env.RELEASE_TAG,
  /** 大同上报应用id */
  datongKey: process.env.DATONG_KEY,
  /** shiply mini-portal 项目参数 */
  miniPortalProjectId: process.env.MINI_PORTAL_PROJECT_ID,
  miniPortalAppId: process.env.MINI_PORTAL_APP_ID,
  miniPortalAppKey: process.env.MINI_PORTAL_APP_KEY,
  aegisKey: process.env.AEGIS_KEY,
  buglyAegisId: process.env.BUGLY_AEGIS_ID,
  buglyAegisAppKey: process.env.BUGLY_AEGIS_APP_KEY,
  buglyEnv: process.env.BUGLY_ENV,
  noticeDBAppId: process.env.NOTICE_DB_APP_ID,
  noticeDBSchemaId: process.env.NOTICE_DB_SCHEMA_ID,
  noticeDBSchemakey: process.env.NOTICE_DB_SCHEMA_KEY,
  wujiNoticeUpdateAppId: process.env.WUJI_NOTICE_UPDATE_APP_ID,
  wujiNoticeUpdateReleaseSchemakey: process.env.WUJI_NOTICE_UPDATE_RELEASE_SCHEMA_KEY,
  wujiNoticeUpdateFeaturesSchemakey: process.env.WUJI_NOTICE_UPDATE_FEATURES_SCHEMA_KEY,
  wujiNoticeUpdateFeatureImagesSchemakey: process.env.WUJI_NOTICE_UPDATE_FEATURE_IMAGES_SCHEMA_KEY,
  djiClientId: process.env.DJI_CLIENT_ID,
};

/** 是否有云端分析/修复能力（专业版 / 海外版不具备） */
export const ENABLE_CLOUD_FIX = ENV.isWOA || ENV.isInternal;
